import { render } from "./ContactsContent.vue?vue&type=template&id=624d8340"
import script from "./ContactsContent.vue?vue&type=script&lang=js"
export * from "./ContactsContent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__